"use strict";

var configPromise = require('../config').configPromise;
var Api = require('./api');

var MODULE_URL = '/api/Modules/';
var ALL_MODULES_URL = '/api/organisations/{0}/modules';

var ModuleApi = {

  /** GET api/Modules */
  getModuleList: function () {
    return configPromise
      .then(function (config) {
        return Api.get(config.apiPath(MODULE_URL));
      });
  },

  getAllModulesForOrganisation(organisationId) {
    return configPromise
      .then(function (config) {
        return Api.get(config.apiPath(ALL_MODULES_URL, [organisationId]));
      });
  },

  saveAllModulesForOrganisation(organisationId, modules) {
    return configPromise
      .then(function (config) {
        return Api.patch(config.apiPath(ALL_MODULES_URL, [organisationId]), modules);
      });
  }

};
module.exports = ModuleApi;
